// Round U fix — where to go after login: back to the protected page you came from (e.g. the nudge mail's
// /?vraag=<id>) when it is a same-app relative path your role may open; otherwise the role default.
export const defaultPathFor = (role) => (role === "admin" ? "/admin" : role === "lezer" ? "/bibliotheek" : "/");

export const postLoginPath = (role, from) => {
  const fallback = defaultPathFor(role);
  if (role === "lezer" || !from) return fallback;
  const path = typeof from === "string" ? from : `${from.pathname || ""}${from.search || ""}`;
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//") || path.includes("\\")) return fallback;
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(path) || path.startsWith("/login")) return fallback;
  if (path.startsWith("/admin") && role !== "admin") return fallback;
  return path;
};

// Fix round 2 — an expired token reloads to /login without router state; api.js parks the origin here.
export const POST_LOGIN_KEY = "tw1_post_login_from";

export const readPostLoginFrom = (state, storage) => {
  if (state?.from) return state.from;
  try {
    return storage?.getItem(POST_LOGIN_KEY) || null;
  } catch {
    return null;
  }
};

export const clearPostLoginFrom = (storage) => {
  try {
    storage?.removeItem(POST_LOGIN_KEY);
  } catch {
    /* fail-soft */
  }
};
